export default __webpack_public_path__ + "static/media/bright-swatches.73bcdb9a81aa101af7ae0db5fefda034.jpg";